export const screenWidths = {
    tiny: 400,
    small: 600,
    medium: 720,
    bigMedium: 980,
};

export const chatWidget = {
    width: 352,
    padding: 8,
};
